import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Margin, usePDF } from "react-to-pdf";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Themnoidung from "components/Tonghopbaocao/Maubaocao20/Themnoidung.js";
import Maubaocao20ct from "components/Tonghopbaocao/Maubaocao20/Maubaocao20ct.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
export default function Maubaocao20() {
  const classes = useStyles();
  const [thangnam, setThangnam] = React.useState(dayjs());
  const [openthem, setOpenthem] = React.useState(false);
  const [thaydoidexuat, setThaydoidexuat] = React.useState(0);
  const handleClose = () => {
    setOpenthem(false);
    setThaydoidexuat(Math.random());
  };
  const { toPDF, targetRef } = usePDF({
    filename: "Baocaohoatdongvantai.pdf",
    page: { margin: Margin.MEDIUM },
  });
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "15%" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Chọn tháng năm"
              value={thangnam}
              onChange={(newValue) => {
                setThangnam(newValue);
              }}
              format="MM/YYYY"
              slotProps={{ textField: { size: "small" } }}
              views={["month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "27px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl style={{ width: "15%", marginLeft: "10px" }}>
          <Button
            color="primary"
            variant="contained"
            style={{ height: 27 }}
            onClick={() => setOpenthem(true)}
          >
            Đề xuất
          </Button>
        </FormControl>
        <FormControl style={{ width: "13%", marginLeft: "10px" }}>
          <Button
            color="success"
            variant="contained"
            style={{ height: 27 }}
            onClick={toPDF}
          >
            Tải file PDF
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <div ref={targetRef} style={{ height: "auto" }}>
          <Maubaocao20ct thangnam={thangnam} thaydoidexuat={thaydoidexuat} />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openthem}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Thuận lợi, khó khăn, đề xuất, kiến nghị
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClose} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Themnoidung thangnam={thangnam} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
    </GridContainer>
  );
}
